import React from "react";
import {TaggedLogger} from "@nextlot/core/utilities";
import NetworkAwareBusyOverlayCmp from "../NetworkAwareBusyOverlayCmp";
import {WebcastStateEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import AuctionsManager from "@nextlot/core/webcast/services/AuctionsManager";
import {ChannelEnum} from "@nextlot/core/webcast/redux/actions";
import {useAppSelector} from "@nextlot/core/webcast/hooks";


const _logger = TaggedLogger.get('ClerkAuctionInfoHeaderCmp');


export default function ClerkAuctionInfoHeaderCmp() {
    return (
        <div className="d-flex justify-content-between">

            <div>
                <h5>{AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.auctionName}
                    &nbsp;&nbsp;
                    <code>#{AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.auctionId}</code></h5>
            </div>

            <div className="d-flex flex-row align-items-center">

                <AuctionDataSyncWidget />


                <div className="position-relative">
                    <NetworkAwareBusyOverlayCmp wbsCommChannel={ChannelEnum.bidding} />

                    <ButtonsForWebcastState />
                </div>
            </div>

        </div>
    )
}



enum SyncWidgetStatesEnum {
    IDLE_SYNC_NOT_REQUIRED = 1,
    IDLE_SYNC_REQUIRED = 2,
    BUSY_SYNC_IN_PROGRESS = 21,
}

function AuctionDataSyncWidget() {
    const webcastHasBiddingFunctionsEnabled = useAppSelector((state) => state.activeWebcast.webcastStatus.biddingFunctionsEnabled);
    const outOfSyncCacheKey = useAppSelector((state) => state.activeWebcast.webcastAuctionData.remoteLotsCacheKeyOutOfSync);

    const [syncWidgetState, setSyncWidgetState] =
        React.useState<SyncWidgetStatesEnum>(outOfSyncCacheKey ? SyncWidgetStatesEnum.IDLE_SYNC_REQUIRED : SyncWidgetStatesEnum.IDLE_SYNC_NOT_REQUIRED);


    React.useEffect(() => {
        setSyncWidgetState(outOfSyncCacheKey ? SyncWidgetStatesEnum.IDLE_SYNC_REQUIRED : SyncWidgetStatesEnum.IDLE_SYNC_NOT_REQUIRED)
    }, [outOfSyncCacheKey])




    const handleClick_SyncApplyNowButton = () => {
        setSyncWidgetState(SyncWidgetStatesEnum.BUSY_SYNC_IN_PROGRESS);
        AuctionsManager.currentWebcastAuctionHandler.controller.sendAuctionDataSyncApply();
    };




    if (syncWidgetState === SyncWidgetStatesEnum.IDLE_SYNC_REQUIRED) {
        return (
            <div className="pe-3">
                <span className="text-danger">out-of-sync:</span><strong className="text-danger">[{outOfSyncCacheKey}]</strong> &nbsp;
                {
                    webcastHasBiddingFunctionsEnabled
                        ? <span className="text-danger">Must PAUSE before SYNC</span>
                        : <button className="btn btn-sm btn-danger" type="button" onClick={handleClick_SyncApplyNowButton}>SYNC NOW</button>
                }
            </div>
        )
    }

    else if (syncWidgetState === SyncWidgetStatesEnum.BUSY_SYNC_IN_PROGRESS) {
        return (
            <div className="pe-3">
                <strong className='text-dark'>Sync in progress ...</strong>
            </div>
        )
    }

    else {
        // IDLE_SYNC_NOT_REQUIRED
        return (
            <div className='pe-3 text-success'>
                {"\u2713"} In sync
            </div>
        )
    }
}



function ButtonsForWebcastState() {
    const webcastStatus = useAppSelector((state) => state.activeWebcast.webcastStatus);

    const handleClick_PauseButton = () => {
        AuctionsManager.currentWebcastAuctionHandler.controller.sendWebcastStatusChange({ pause: ! webcastStatus.paused });
    };



    const handleClick_CloseButton = () => {
        if (window.confirm("Confirm closing the webcast event?")) {
            AuctionsManager.currentWebcastAuctionHandler.controller.sendWebcastStatusChange({ close: true });
        }
    };

    const handleClick_StartWebcastButton = () => {
        AuctionsManager.currentWebcastAuctionHandler.controller.sendWebcastStatusChange({ start: true });
    };


    if (webcastStatus.state === WebcastStateEnum.WEBCAST_STATE__LOBBY) {
        return (
            <button className="btn btn-sm btn-success" onClick={handleClick_StartWebcastButton}>Start Webcast event</button>
        )
    }
    else {
        return (
            <div className="d-inline-flex flex-row justify-content-end align-items-center">
                <button className={`btn btn-sm ${webcastStatus.paused ? 'btn-danger' : 'btn-outline-secondary'}`} onClick={handleClick_PauseButton}>{webcastStatus.paused ? 'Resume' : 'Pause'}</button>
                &nbsp;
                <button className={'btn btn-sm btn-outline-secondary'} onClick={handleClick_CloseButton}>Close</button>
            </div>

        )
    }
}

